import useRelatedReturns from "@babackapp/private-api-client/client/use-related-returns";
import useTranslation from "@babackapp/translations/use-translation";
import { Skeleton } from "@babackapp/ui/components/skeleton";
import { Link } from "react-router-dom";

interface RelatedReturnsProps {
  returnRequestId: string;
  shopId: string;
}

export default function RelatedReturns(props: RelatedReturnsProps) {
  const t = useTranslation();
  const { data, isPending } = useRelatedReturns({
    returnRequestId: props.returnRequestId,
    shopId: props.shopId,
  });

  return (
    <div>
      <h2 className="text-sm font-medium text-gray-500">
        {t("misc.otherRequest")}
      </h2>
      <div className={"flex flex-col "}>
        {isPending ? (
          <>
            <Skeleton className={"h-8 w-full rounded"} />
            <Skeleton className={"h-8 w-full rounded"} />
            <Skeleton className={"h-8 w-full rounded"} />
          </>
        ) : data ? (
          data.map((returnRequest) => {
            return (
              <Link
                key={returnRequest.id}
                to={`/shops/${props.shopId}/returns/${returnRequest.id}`}
                className="cursor-pointer text-sm font-medium text-gray-900 hover:text-purple-600"
              >
                {returnRequest.shipping_info.tracking_code
                  ? returnRequest.shipping_info.tracking_code
                  : returnRequest.id.toUpperCase()}
              </Link>
            );
          })
        ) : (
          <span>{t("newOrder.sumup.noRelatedReturn")}</span>
        )}
      </div>
    </div>
  );
}
